/**
 * Care Tab navigation helpers.
 *
 * Cypress can install window hooks (`__careOpenDeeplink` /
 * `__careOpenTrackingUrl`) before load so E2E specs can assert deeplink /
 * tracking opens without assigning `window.location` (unforgeable in Chrome).
 * Production builds leave the hooks unset and keep the original behavior.
 */

declare global {
  interface Window {
    __careOpenDeeplink?: (url: string) => void;
    __careOpenTrackingUrl?: (url: string) => void;
    __careFlags?: {
      nativePrescriptionPage?: boolean;
      supplementTreatmentDetail?: boolean;
      biomarkerTreatmentDetail?: boolean;
    };
  }
}

export const openDeeplink = (deeplink: string) => {
  if (window.__careOpenDeeplink) {
    window.__careOpenDeeplink(deeplink);
    return;
  }
  window.location.href = deeplink;
};

export const openTrackingUrl = (trackingUrl: string) => {
  if (window.__careOpenTrackingUrl) {
    window.__careOpenTrackingUrl(trackingUrl);
    return;
  }
  // Mobile webviews treat real link activations differently from JS URL
  // assignment. Long term, the Wax TreatmentCard CTA should support an
  // `href` so tracking links can render as anchors directly.
  const anchor = document.createElement("a");
  anchor.href = trackingUrl;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
